import React from "react";
import { PhoneCall, Banknote, Globe2 } from "lucide-react";
import { FEATURES } from "../../mock";

const ICONS = {
  phone: { Comp: PhoneCall, color: "#009688", bg: "rgba(0,150,136,0.10)" },
  savings: { Comp: Banknote, color: "#388e3c", bg: "rgba(56,142,60,0.10)" },
  globe: { Comp: Globe2, color: "#1565c0", bg: "rgba(21,101,192,0.10)" },
};

const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-[820px] mx-auto px-6 flex flex-col gap-5">
        {FEATURES.map((f) => {
          const cfg = ICONS[f.icon];
          const Icon = cfg.Comp;
          return (
            <div
              key={f.id}
              className="rounded-2xl bg-white border border-[#eceef3] shadow-[0_4px_18px_rgba(20,40,76,0.05)] px-6 py-6 flex items-start gap-4 transition-shadow duration-300 hover:shadow-[0_10px_28px_rgba(20,40,76,0.10)]"
            >
              <div
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
                style={{ backgroundColor: cfg.bg }}
              >
                <Icon className="h-6 w-6" style={{ color: cfg.color }} />
              </div>
              <div>
                <h4 className="text-[18px] font-bold" style={{ color: "var(--me-heading)" }}>
                  {f.title}
                </h4>
                <p className="mt-1.5 text-[15px] leading-relaxed" style={{ color: "var(--me-text)" }}>
                  {f.text}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturesSection;
